import i18next from "i18next";

import en from "./en";
import vi from "./vi";

i18next.addResourceBundle("en", "common", en);
i18next.addResourceBundle("vi", "common", vi);
